module.exports={
  "name": "@truffle/contract",
  "description": "A better contract abstraction for Ethereum (formerly EtherPudding)",
  "license": "MIT",
  "author": "Tim Coulter <tim@trufflesuite.com>",
  "homepage": "https://github.com/trufflesuite/truffle/tree/master/packages/contract#readme",
  "repository": {
    "type": "git",
    "url": "https://github.com/trufflesuite/truffle.git",
    "directory": "packages/contract"
  },
  "bugs": {
    "url": "https://github.com/trufflesuite/truffle/issues"
  },
  "version": "4.5.3",
  "main": "index.js",
  "scripts": {
    "build": "yarn compile",
    "compile": "sh -c \"mkdir -p ./dist\" && browserify --debug ./index.js | exorcist ./dist/truffle-contract.js.map > ./dist/truffle-contract.js && uglifyjs ./dist/truffle-contract.js -o ./dist/truffle-contract.min.js",
    "prepare": "yarn compile",
    "publish:next": "node ../truffle/scripts/prereleaseVersion.js next next"
  },
  "typings": "./typings/index.d.ts",
  "dependencies": {
    "@ensdomains/ensjs": "^2.0.1",
    "@truffle/blockchain-utils": "^0.1.1",
    "@truffle/contract-schema": "^3.4.6",
    "@truffle/debug-utils": "^6.0.15",
    "@truffle/error": "^0.1.0",
    "@truffle/interface-adapter": "^0.5.12",
    "bignumber.js": "^7.2.1",
    "debug": "^4.3.1",
    "ethers": "^4.0.32",
    "web3": "1.5.3",
    "web3-core-helpers": "1.5.3",
    "web3-core-promievent": "1.5.3",
    "web3-eth-abi": "1.5.3",
    "web3-utils": "1.5.3"
  },
  "devDependencies": {
    "browserify": "^17.0.0",
    "exorcist": "^2.0.0",
    "uglify-es": "^3.3.9"
  },
  "keywords": [
    "abstraction",
    "contract",
    "ethereum",
    "truffle"
  ],
  "publishConfig": {
    "access": "public"
  },
  "gitHead": "5c7b580bb16ea1a4b42a5430574171a905cb8199"
}
